export * from "gatsby-theme-themed-gatsby-link";
export { Link as default } from "gatsby-theme-themed-gatsby-link";
